import React from 'react'
import PropTypes from 'prop-types'
import { createGlobalStyle } from 'styled-components'
import CommonText from './CommonText'
import CommonInput from './CommonInput'

const CommonFormInput = ({
  name,
  type,
  className,
  label = '',
  fontWeight = 400,
  fontSize = 16,
  tag = 'h2',
  width = 315,
  placeholder,
  defaultValue,
  onChange,
  disabled,
  ...props
}) => {
  return (
    <>
      <div style={{ ...props.style }} className={className}>
        <CommonLabelStyle />
        <CommonText
          className="form-label"
          fontWeight={fontWeight}
          fontSize={fontSize}
          tag={tag}>
          {label}
        </CommonText>
        <CommonInput
          name={name}
          type={type}
          width={width}
          placeholder={placeholder}
          defaultValue={defaultValue}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
    </>
  )
}

CommonFormInput.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  fontWeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tag: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
}

const CommonLabelStyle = createGlobalStyle`
.form-label {
  margin: 0;
  margin-bottom: 15px;
}
`

export default CommonFormInput
